import { jsx as _jsx } from "react/jsx-runtime";
import { toClassName } from '../../utils/ClassNameUtils.js';
export function ButtonGroup({ centered, hasAddons, noBottomMargin, children }) {
    return (_jsx("div", { className: toClassName('buttons', centered && 'is-centered', hasAddons && 'has-addons', noBottomMargin && 'mb-0'), children: children }));
}
//# sourceMappingURL=ButtonGroup.js.map